import { render, staticRenderFns } from "./HVideo.vue?vue&type=template&id=afa8ec92&scoped=true&"
import script from "./HVideo.vue?vue&type=script&lang=js&"
export * from "./HVideo.vue?vue&type=script&lang=js&"
import style0 from "./HVideo.vue?vue&type=style&index=0&id=afa8ec92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa8ec92",
  null
  
)

export default component.exports